'use client';
import { useAuth } from '@/contexts/AuthContext';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import AppLayout from '@/components/AppLayout';
import DisputesContent from './components/DisputesContent';

export default function DisputesPage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && !user) {
      router?.push('/sign-up-login-screen');
    }
  }, [user, loading, router]);

  if (loading || !user) return null;

  return (
    <AppLayout role="customer">
      <DisputesContent />
    </AppLayout>
  );
}
